// src/components/SceneLayers/Nodes/Node/IconTypes/LucideIcon.tsx
// ✅ FIXED: Added isometric projection to match NonIsometricIcon behavior

import { useRef} from 'react';
import { Box } from '@mui/material';
import { LucideIcon as LucideIconType } from 'lucide-react';
import { PROJECTED_TILE_SIZE } from 'src/config';
import { useModelStore } from 'src/stores/modelStore';
import { getIsoProjectionCss } from 'src/utils';

interface Props {
  IconComponent: LucideIconType;
  nodeId: string;
}

export const LucideIcon = ({ IconComponent, nodeId }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  // const [size, setSize] = useState({ width: 0, height: 0 });

  // Use Zustand selector for reactive color updates
  const color = useModelStore((state) => {
    const item = state.items.find((item) => item.id === nodeId);
    const itemColor = item?.color || '#3b82f6';
    return itemColor;
  });

  // useEffect(() => {
  //   if (ref.current) {
  //     const { width, height } = ref.current.getBoundingClientRect();
  //     setSize({ width, height });
  //   }
  // }, []);

  const iconWidth = PROJECTED_TILE_SIZE.width * 0.7;

  return (
    <Box sx={{ pointerEvents: 'none' }}>
      {/* ✅ NEW: Outer container with isometric projection (same as NonIsometricIcon) */}
      <Box
        sx={{
          position: 'absolute',
          left: -PROJECTED_TILE_SIZE.width / 2,
          top: -PROJECTED_TILE_SIZE.height / 2,
          transformOrigin: 'top left',
          transform: getIsoProjectionCss() // ← KEY FIX: Apply isometric projection
        }}
      >
        {/* Inner container for the icon */}
        <Box
          ref={ref}
          sx={{
            width: PROJECTED_TILE_SIZE.width * 0.7,
            height: PROJECTED_TILE_SIZE.width * 0.7,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            pointerEvents: 'none'
          }}
        >
          <IconComponent
            size={iconWidth * 0.8}
            color={color}
            strokeWidth={1.5}
          />
        </Box>
      </Box>
    </Box>
  );
};